import { useState } from "react";
import { mediaUrl } from "@/lib/api";

// Renders an author/user avatar image, gracefully falling back to the initial
// letter if there's no picture or the image fails to load (e.g. an old
// Community post referencing an avatar that was later removed/replaced).
export function Avatar({ picture, name }) {
  const [err, setErr] = useState(false);
  const initial = ((name || "A")[0] || "A").toUpperCase();
  if (picture && !err) {
    return <img src={mediaUrl(picture)} alt="" className="h-full w-full object-cover" onError={() => setErr(true)} />;
  }
  return <span className="flex h-full w-full items-center justify-center">{initial}</span>;
}
